"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementContextProviderComponent = void 0;
var AgreementContextProvider_1 = require("@CommonFrontend/AgreementView/AgreementContextProvider");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var AcceptButtonSettingsHelper_1 = require("@CommonFrontendBackend/Accept/AcceptButtonSettingsHelper");
var inversify_react_1 = require("inversify-react");
var react_1 = __importDefault(require("react"));
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var AgreementContextProviderComponent = function (_a) {
    var children = _a.children;
    var project = (0, inversify_react_1.useInjection)("project");
    var acceptBlock = project.blocks.find(function (block) { return block.type === BlockTypes_1.BlockType.Accept; });
    var color = (0, AcceptButtonSettingsHelper_1.deriveAcceptButtonColor)(acceptBlock);
    return (react_1.default.createElement(AgreementContextProvider_1.AgreementContextProvider, { buttonColor: color, disableNavigationButton: ![Types_1.ProjectStatus.Live, Types_1.ProjectStatus.Draft].includes(project.status), isPrintMode: false }, children));
};
exports.AgreementContextProviderComponent = AgreementContextProviderComponent;
